import React from 'react';
import styles from './Label.module.scss';
import classNames from 'classnames';

interface Props {
  element?: string;
  children?: React.ReactNode;
  className?: string;
  variant?: 'success' | 'default' | 'muted' | 'muted-danger' | 'danger' | 'muted-info';
  size?: 'small' | 'medium' | 'large';
  uppercase?: boolean;
  rounded?: boolean;
}

const Label: React.FC<Props> = props => {
  const containerClass = classNames(
    styles.container,
    styles[`variant-${props.variant}`],
    styles[`size-${props.size}`],
    props.className,
    {
      [styles.rounded]: props.rounded,
      [styles.uppercase]: props.uppercase,
    }
  );

  return React.createElement(
    props.element || 'span',
    {
      className: containerClass,
    },
    props.children
  );
};

Label.defaultProps = {
  element: 'span',
  variant: 'default',
  size: 'medium',
  uppercase: true,
};

export default Label;
